import React, { useState, useEffect } from 'react';
import lib from 'lib/commons';
import config from 'config/common';
import io from 'socket.io-client';
import ReactTooltip from 'react-tooltip';

import Spin from './Spin';
import Accumulated from './Accumulated';

let socket;
let timeoutClick;

const HomeView = ({
	lng,
	currentUser: data = {},
	currentUser: {
		user: { id: userId = null, uid = null } = {},
		socket_account_id,
		socket_env,
	},
	share,
	checkMatch,
	spin,
	doClaim,
	refresh,
	claimClub,
	updateJackpot,
	updateWinnerJackpot,
	updateWinnerSemiJackpot,
}) => {
	useEffect(() => {
		ReactTooltip.rebuild();
	});

	useEffect(() => {
		AOS.init({
			easing: 'ease-out-back',
			duration: 1200,
			offset: -80,
		});
		setTimeout(() => {
			const element = document.getElementById('status');
			element.scrollIntoView({ behavior: 'smooth' });
		}, 500);
	}, []);

	const connectSocket = () => {
		const opts = {
			forceNew: true,
			reconnection: false,
			path: '/io',
			withCredentials: true,
			transports: ['websocket'],
			query: {
				account_id: socket_account_id,
			},
			// transportOptions: {
			//   polling: {
			//     extraHeaders: {
			//       "access-token": socketToken
			//     }
			//   }
			// }
			// extraHeaders: {
			//   "access-token": socketToken
			// }
		};
		socket = io(`https://sock.bis.fo4.garena.vn`, opts);

		socket.on('connect', () => {
			window.ffbis20 = socket;
		});

		socket.on('message', (data) => {
			// console.log('data', data)
			// console.log('socket_env', socket_env)
			if (socket_env != data.content.env) {
				return;
			}
			if (data.content.type == 'jackpot_value') {
				updateJackpot(data?.content?.value);
			}
			if (data.content.type == 'winner') {
				//3 jackpot, 2: giai nhi
				if (data.content.reward_type == 3) {
					updateWinnerJackpot({
						value: data.content.value,
						nickname: data.content.nickname,
					});
				}
				if (data.content.reward_type == 2) {
					updateWinnerSemiJackpot({
						value: data.content.value,
						nickname: data.content.nickname,
					});
				}
			}
			if (data.content.type == 'jackpot') {
				updateWinnerJackpot({
					value: data.content.value,
					nickname: data.content.nickname,
				});
			}
			if (data.content.type == 'mini_jackpot') {
				updateWinnerSemiJackpot({
					value: data.content.value,
					nickname: data.content.nickname,
				});
			}
		});
	};

	useEffect(() => {
		if (socket_account_id && socket_env) {
			connectSocket();
		}
	}, [socket_account_id, socket_env]);

	return (
		<>
			<div className="main-content main-home">
				<div id="status"></div>
				<Spin
					data={data}
					share={share}
					checkMatch={checkMatch}
					spin={spin}
					refresh={refresh}
					claimClub={claimClub}
				/>

				<Accumulated data={data} doClaim={doClaim} />
			</div>
			<ReactTooltip html={true} />
		</>
	);
};

export default HomeView;
